import React from "react";

const ConsentToggles = ({ data, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          id="consent"
          checked={data.parentConsentRequired || false}
          onChange={(e) => onChange("parentConsentRequired", e.target.checked)}
          className="h-4 w-4 text-blue-600 border-gray-300 rounded"
        />
        <label htmlFor="consent" className="text-gray-700">
          Parent/Caregiver Consent required
        </label>
      </div>

      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          id="rolls"
          checked={data.rollsMarked || false}
          onChange={(e) => onChange("rollsMarked", e.target.checked)}
          className="h-4 w-4 text-blue-600 border-gray-300 rounded"
        />
        <label htmlFor="rolls" className="text-gray-700">
          Will rolls be marked?
        </label>
      </div>
    </div>
  );
};

export default ConsentToggles;
